import _ from 'lodash'

import {
  destinationCountQueryParams,
  durationQueryParams,
  filters as configFilters,
  filterKeys,
  getListFilterKeysForQueryParams,
} from '../../configuration/filtering'
import { parseMinMax, split } from '../../utilities/filters/parsers'

export const CLEAR_FILTER = 'CLEAR_FILTER'
export const CONFIGURE_FILTERS = 'CONFIGURE_FILTERS'
export const RESET_FILTER_STATE = 'RESET_FILTER_STATE'
export const UPDATE_FILTER = 'UPDATE_FILTER'
export const UPDATE_MULTIPLE_FILTERS = 'UPDATE_MULTIPLE_FILTERS'
export const UPDATE_EXACT_MATCH_FILTERS = 'UPDATE_EXACT_MATCH_FILTERS'

export const clearAllFilters = () => {
  return dispatch => {
    dispatch({ type: RESET_FILTER_STATE })
  }
}

export const clearFilter = (filterKey) => {
  return dispatch => {
    dispatch({
      type: CLEAR_FILTER,
      payload: filterKey,
    })
  }
}

export const configureSearchFilters = (queryParams) => (dispatch) => {
  const validListFiltersKeys = getListFilterKeysForQueryParams()
  const filters = {}
  _.forEach(queryParams, (params, paramKey) => {
    const isValidDestinationCountFilter = Boolean(_.find(destinationCountQueryParams, filterKey => _.toLower(filterKey) === _.toLower(paramKey)))
    const isValidDurationFilter = Boolean(_.find(durationQueryParams, filterKey => _.toLower(filterKey) === _.toLower(paramKey)))
    const isValidListFilter = Boolean(_.find(validListFiltersKeys, filterKey => _.toLower(filterKey) === _.toLower(paramKey)))

    // destination count filer
    if (isValidDestinationCountFilter && !filters[filterKeys.destinationCount]) {
      const destinationCountfilter = parseMinMax(
        _.get(queryParams, `[${destinationCountQueryParams[0]}]`),
        _.get(queryParams, `[${destinationCountQueryParams[1]}]`)
      )
      if (destinationCountfilter) {
        filters[filterKeys.destinationCount] = destinationCountfilter
      }

    // duration dilter
    } else if (isValidDurationFilter && !filters[filterKeys.duration]) {
      const durationfilter = parseMinMax(
        _.get(queryParams, `[${durationQueryParams[0]}]`),
        _.get(queryParams, `[${durationQueryParams[1]}]`)
      )
      if (durationfilter) {
        filters[filterKeys.duration] = durationfilter
      }
    
    // all other list filters
    } else if (isValidListFilter && params) {
      filters[paramKey] = split(params)
    }
  })

  if (_.has(queryParams, 'matchExactly')) {
    const exactMatchFilters = split(_.get(queryParams, 'matchExactly'))
    const validatedExactMatchFilters = _.filter(exactMatchFilters, filterKey => {
      const associatedFilters = _.get(filters, `[${filterKey}]`)
      return !_.isEmpty(associatedFilters)
        && Boolean(_.get(configFilters, `[${filterKey}].hasExactMatchOption`))
    })
    filters.matchExactly = validatedExactMatchFilters
  }

  dispatch({ type: CONFIGURE_FILTERS, payload: filters })
}

export const updateExactMatchFilter = (filterKey, action) => (dispatch, getState) => {
  const exactMatchFilters = _.get(getState(), 'filtersData.matchExactly')
  // action is either _.concat or _.without depending on active state
  const updatedFilters = action(exactMatchFilters, filterKey)
  dispatch({ type: UPDATE_EXACT_MATCH_FILTERS, payload: updatedFilters })
}

export const updateFilter = (filterKey, filters) => {
  return dispatch => {
    dispatch({
      type: UPDATE_FILTER,
      payload: { filterKey, filters },
    })
  }
}

export const updateMultipleFilters = (filters) => {
  return dispatch => {
    dispatch({
      type: UPDATE_MULTIPLE_FILTERS,
      payload: filters,
    })
  }
}
